exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style__wrapper___2UawX{display:flex;width:100%;min-height:97px;border-radius:6px;box-shadow:0 1px 9px 0 rgba(0,0,0,0.05);background-color:#ffffff;align-items:center;padding:15px}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "style__wrapper___2UawX"
};